import type { TierName, TierNameUpperCase } from '@bond/bruce-api/common/tier'

export function toTierName(tier: TierNameUpperCase) {
  return `${tier.charAt(0)}${tier.slice(1).toLowerCase()}` as TierName
}
